export default __webpack_public_path__ + "static/media/logo.f72566c6.png";